import { Col, Icon, Modal, Row, Tabs } from 'antd';
import { LanguageContext } from 'contexts/LanguageContext';
import { Bitrix24Consumer } from 'contexts/legacy/Bitrix24Context';
import { SystemConsumer } from 'contexts/legacy/SystemContext';
import { useContext, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Navigate } from 'react-router-dom';
import ConnectedChannelsView from './ConnectedChannels';
import MessageCount from './MessageCount';
import NumberProView from './Numbers/NumberProView';
import NumberView from './Numbers/NumberView';
import SubscriptionView from './Subscription/SubscriptionView';
import { TermsOfUseView } from './TermsOfUse';
import TutorialsView from './Tutorials';
import MigrateToKoryView from './MigrateToKory';
import CallsExportView from './CallsExport';
import logoSingleSm from 'assets/icons/logo-single-sm.png';
import BillingView from './Billing/BillingView';
import MarketingCampaignView from './MarketingCampaign/MarketingCampaignView';
import PermissionIndex from 'components/Permissions/Permissions';
import InsightsView from './Insights';
import { api } from 'services/api';
import SurveyPageMarker from 'components/Survey/SurveyPageMarker';
import { PageView } from 'components/Analytics/PageViewTracker';

const { TabPane } = Tabs;

// As abas não são rotas: cada uma é registrada no Mixpanel como uma tela, com o nome que teria como rota.
const TAB_PAGE_NAMES = {
	1: '/',
	2: '/marketing',
	3: '/insights',
	4: '/permissions',
	5: '/billing',
	6: '/help',
	7: '/migrate-to-kory',
	8: '/calls-export',
};

function MainPage({ system, bitrix24 }) {
	const { dictionary } = useContext(LanguageContext);
	const [activeTabKey, setActiveTabKey] = useState('1');
	const [activeTabTutorialKey, setActiveTabTutorialKey] = useState('8');
	const [isInsightsAvailable, setIsInsightsAvailable] = useState();

	useEffect(() => {
		const fetchData = async () => {
			const auth = bitrix24.infos.auth;
			const domain = bitrix24.infos.domain;

			try {
				const { data } = await api.get(`features/insights_enabled?auth=${auth}&domain=${domain}`);

				if (data.status) {
					setIsInsightsAvailable(data.insightsEnabled);
				}
			} catch (error) {
				console.log('Erorr fetching data', error);
			}
		};

		fetchData();
	}, [bitrix24.infos.auth, bitrix24.infos.domain]);

	if (system.gotostep) {
		return <Navigate to={`${process.env.PUBLIC_URL}/step`} />;
	}

	if (window.mobileCheck()) {
		return <Navigate to={`${process.env.PUBLIC_URL}/mobile`} />;
	}

	const handleClickWidget = () => {
		setActiveTabKey('6');
		setActiveTabTutorialKey('9');
	};

	const renderInsightsView = () => {
		if (window.BX24.isAdmin() && isInsightsAvailable) {
			return (
				<TabPane
					tab={
						<div style={{ fontWeight: 'bold', fontSize: '14px' }}>
							<Icon type="bulb" theme="twoTone" />
							<FormattedMessage id="insights" />
						</div>
					}
					key="3"
				>
					<SurveyPageMarker pageId="insight" />
					<Row>
						<InsightsView
							activeTabTutorialKey={activeTabTutorialKey}
							setActiveTabTutorialKey={setActiveTabTutorialKey}
						/>
					</Row>
				</TabPane>
			);
		}

		if (!isInsightsAvailable) {
			return (
				<TabPane
					tab={
						<div style={{ fontWeight: 'bold', fontSize: '14px' }}>
							<Icon type="bulb" theme="twoTone" />
							<FormattedMessage id="insights" />
						</div>
					}
					key="3"
				>
					<SurveyPageMarker pageId="insight" />
					<Row>
						<InsightsView
							activeTabTutorialKey={activeTabTutorialKey}
							setActiveTabTutorialKey={setActiveTabTutorialKey}
						/>
					</Row>
				</TabPane>
			);
		}
	};

	return (
		<>
			<PageView pageName={TAB_PAGE_NAMES[activeTabKey]} />
			<div
				style={{ backgroundColor: '#eee', height: '100%' }}
				className={activeTabKey === '7' ? 'kory-tab-active' : ''}
			>
				<Tabs
					defaultActiveKey="1"
					activeKey={activeTabKey}
					onChange={setActiveTabKey}
					style={{ backgroundColor: '#eee', height: 'auto', marginLeft: '2px' }}
					tabBarGutter={3}
				>
					<TabPane
						tab={
							<div style={{ fontWeight: 'bold', fontSize: '14px' }}>
								<Icon type="setting" theme="twoTone" />
								<FormattedMessage id="dashboard_tab_title" />{' '}
							</div>
						}
						key="1"
					>
						<SurveyPageMarker pageId="home" />
						<Row>
							<Col span={16}>
								<NumberProView />
								<NumberView
									setActiveTabKey={setActiveTabKey}
									setActiveTabTutorialKey={setActiveTabTutorialKey}
								/>
								<MessageCount />
							</Col>
							<Col span={8}>
								<SubscriptionView setActiveTabKey={setActiveTabKey} />
								<ConnectedChannelsView />
								<TermsOfUseView />
								{/*<LastUpdateView />*/}
							</Col>
						</Row>
					</TabPane>

					<TabPane
						tab={
							<div style={{ fontWeight: 'bold', fontSize: '14px' }}>
								<Icon type="mail" theme="twoTone" />
								<FormattedMessage id="marketing_campaigns_tab_title" />{' '}
							</div>
						}
						key="2"
					>
						<SurveyPageMarker pageId="marketing" />
						<Row>
							<MarketingCampaignView
								setActiveTabKey={setActiveTabKey}
								setActiveTabTutorialKey={setActiveTabTutorialKey}
							/>
						</Row>
					</TabPane>

					{renderInsightsView()}

					{window.BX24.isAdmin() ? (
						<TabPane
							tab={
								<div style={{ fontWeight: 'bold', fontSize: '14pxan' }}>
									<Icon type="lock" theme="twoTone" />
									<FormattedMessage id="permissions_tab_title" />
								</div>
							}
							key="4"
						>
							<SurveyPageMarker pageId="permission" />
							<Row>
								<PermissionIndex
									setActiveTabKey={setActiveTabKey}
									setActiveTabTutorialKey={setActiveTabTutorialKey}
								/>
							</Row>
						</TabPane>
					) : null}

					{window.BX24.isAdmin() ? (
						<TabPane
							tab={
								<div style={{ fontWeight: 'bold', fontSize: '14px' }}>
									<Icon type="dollar" theme="twoTone" />
									<FormattedMessage id="billing_central_tab_title" />{' '}
								</div>
							}
							key="5"
						>
							<SurveyPageMarker pageId="billing" />
							<Row>
								<BillingView />
							</Row>
						</TabPane>
					) : null}

					<TabPane
						tab={
							<div style={{ fontWeight: 'bold', fontSize: '14px' }}>
								<Icon type="question-circle" theme="twoTone" />
								<FormattedMessage id="help_tab_title" />{' '}
							</div>
						}
						className="ant-help-tab"
						key="6"
					>
						<SurveyPageMarker pageId="help" />
						<Row>
							<TutorialsView
								setActiveTabKey={setActiveTabKey}
								activeTabTutorialKey={activeTabTutorialKey}
								setActiveTabTutorialKey={setActiveTabTutorialKey}
							/>
						</Row>
					</TabPane>

					{window.BX24.isAdmin() ? (
						<TabPane
							tab={
								<div
									style={{
										fontWeight: 'bold',
										fontSize: '14px',
										color: '#FF684A',
										display: 'flex',
										alignItems: 'center',
										gap: 6,
									}}
								>
									<img src={logoSingleSm} alt="Kory One" style={{ height: 16, width: 'auto' }} />
									<FormattedMessage id="migrate_kory_card_migrate_title" />
								</div>
							}
							key="7"
						>
							<Row>
								<MigrateToKoryView />
							</Row>
						</TabPane>
					) : null}

					{window.BX24.isAdmin() &&
					bitrix24.auth?.domain === process.env.REACT_APP_CALLS_EXPORT_DOMAIN ? (
						<TabPane
							tab={
								<div style={{ fontWeight: 'bold', fontSize: '14px' }}>
									<Icon type="download" theme="twoTone" />
									<FormattedMessage id="calls_export_tab_title" />
								</div>
							}
							key="8"
						>
							<Row>
								<CallsExportView />
							</Row>
						</TabPane>
					) : null}
				</Tabs>
			</div>

			<Modal
				content={dictionary.alert_message}
				visible={bitrix24.authentication_failure && !bitrix24.isAdmin}
				closeable={false}
				footer={null}
				closeIcon={null}
				width={'60%'}
				headStyle={{ color: '#141414', backgroundColor: '#fff1b8' }}
				bodyStyle={{ color: '#141414', backgroundColor: '#fff1b8' }}
			>
				<Row>
					<Col>
						<div>
							<h4>{dictionary.alert_title}</h4>
							<p style={{ fontSize: 'large' }}>{dictionary.alert_message}</p>
						</div>
					</Col>
				</Row>
			</Modal>
		</>
	);
}

export default SystemConsumer(Bitrix24Consumer(MainPage));
